import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { EmailService } from '../../services/email.service';
import * as pbi from 'powerbi-client'
import { hpmFactory, routerFactory, wpmpFactory } from 'factories';

@Component({
  selector: 'app-power-bireport',
  templateUrl: './power-bireport.component.html',
  styleUrls: ['./power-bireport.component.scss']
})
export class PowerBireportComponent implements OnInit {
  @ViewChild('reportContainer') reportContainer: ElementRef;
  constructor(private EmailService: EmailService) { }

  ngOnInit() {
  //   this.EmailService.ExportReportToPDF('2e79cd7f-0cc2-4c63-ae33-9d96b90c6dfd','7ba52bdd-cd28-4cff-bc9e-b2591991e5e6').subscribe(data => {
      
  //     console.log(data);
  //     const byteCharacters = atob(data);
  //           const byteNumbers = Array.from(byteCharacters, (char) => char.charCodeAt(0));
  //           const byteArray = new Uint8Array(byteNumbers);
  //           const blob = new Blob([byteArray], { type: 'application/pdf' });
  //           const url = window.URL.createObjectURL(blob);
  //           const link = document.createElement('a');
  //           link.href = url;
  //           link.download = 'invoice.pdf'; // File name for download
  //           link.target='_blank';
  //           link.click();

  //     // Get Power BI service instance
  //    //const hpmFactory:any;

  //     // const powerbiService = new pbi.service.Service();

  //     // // Clear existing report
  //     // powerbiService.reset(this.reportContainer.nativeElement);

  //     // // Embed the report
  //     // powerbiService.embed(this.reportContainer.nativeElement, embedConfig);
  //   }, error => {
  //     console.error('Error fetching embed token:', error);
  //   });
   }
}


// WEBPACK FOOTER //
// ./src/app/shared-components/power-bireport/power-bireport.component.ts